import { fn } from 'storybook/test';

import type { Meta, StoryFn } from '@storybook/react';
import type { ToggleSwitchProps } from './ToggleSwitch';

import { ToggleSwitch } from './ToggleSwitch';

const codeString = `
// Has all InputHTMLAttributes props available except "className" and "style" 
<ToggleSwitch onChange={onChangeFunction} checked={checked} label={label} />
`;

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Atoms/ToggleSwitch',
  component: ToggleSwitch,
  parameters: {
    inspectComponent: ToggleSwitch,
    codeString: codeString,
  },
} as Meta<ToggleSwitchProps>;

const Template: StoryFn<ToggleSwitchProps> = (args) => {
  return <ToggleSwitch {...args} />;
};

const defaultArgs: Partial<ToggleSwitchProps> = {
  label: 'Toggle switch example',
  labelPosition: 'before',
  onChange: fn(),
};

export const ToggleSwitchExample = Template.bind({});
ToggleSwitchExample.args = {
  ...defaultArgs,
};
